
export default function testCltr(initVal, typedVal, time, acc) {
  // Calculate mistakes
  const mstks = typedVal.split('').reduce((acc, typedChar, index) => {
      return typedChar !== initVal[index] ? acc + 1 : acc;
  }, 0);

  const CPM = (typedVal.length - mstks);
  const WPM = (CPM / 5);
  const speedScore = (WPM) / 2;
  const mistakePenalty = (mstks / initVal.length) * 100;

  return {
      mstks,
      CPM,
      WPM,
      speedScore,
      mistakePenalty,
  };
}
